import * as types from './types';
import * as actionTypes from './constants';
import { IAction } from '@state/types';

const defaultState: types.IUserAccessState = { };

const designTypeReducer = (
  state: types.IUserAccessState = defaultState, 
  action: IAction | types.ISetUserAccessAction
) => {
  switch ((action as IAction).type) {
    case actionTypes.SET_USERACCESSES: {
      return {...state, userAccesses :(action as types.ISetUserAccessesAction).userAccesses};
    }
    case actionTypes.ADD_SUCCESS: {
      return {...state, response: (action as types.IServerSuccessAction).response};
    }
    case actionTypes.PUT_SUCCESS: {
      return {...state, putSuccess: (action as types.IServerSuccessAction).response};
    }
    case actionTypes.CLEAR_DELETE_USERACCESS:{
      return {...state, deletedUserAccess:false};
    }
    case actionTypes.DELETE_USERACCESS_SUCCESS: {
      return {...state, deletedUserAccess:true};
    }
    case actionTypes.SET_SEARCH_USERACCESS: {
      return {...state, searches: (action as types.ISetSearchAction).searches};
    }
    case actionTypes.SET_COUNTER_USERACCESS: {
      return {...state, counter: (action as types.ISetCounterAction).counter};
    }
    default: {
      return state;
    }
  }
};


export default designTypeReducer;
